import { render } from "./ChangeSuperAdminDialog.vue?vue&type=template&id=1aa2132d"
import script from "./ChangeSuperAdminDialog.vue?vue&type=script&lang=js"
export * from "./ChangeSuperAdminDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__